const translations = { required: 'Campo obligatorio', invalidEmail: 'Email inválido' }

export default translations
